import styled from 'styled-components';

export const StyledScreen = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.backgroundPrimary};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.regular};
`;

export const StyledBrand = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  font-family: ${({ theme }) => theme.fonts.bold};
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes.l}px;
`;

export const StyledLogoMark = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary}, #6d5efc);
  color: ${({ theme }) => theme.colors.onPrimary};
  font-weight: 700;
`;

export const StyledHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
`;

export const StyledBody = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.xxl}px ${({ theme }) => theme.spacing.xl}px;
`;

export const StyledLoadMore = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing.l}px;
`;

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: ${({ theme }) => theme.spacing.m}px;
`;
